<template>
    <div class="page--forgot-pass bg-dashed-circle">
        <header-section hide-navbar />
        <div class="container pb-5">
            <div class="row forgot-pass--content">
                <div class="col-5 forgot-pass--img  d-flex justify-content-center">
                    <AnimationPasswordForgot id="reset-password-animation" />
                </div>
                <div class="col-7 forgot-pass--text fast">
                    <h1>Restablecer Contraseña</h1>
                    <p>A continuación ingrese su nueva contraseña. <br />Recuerda que una vez cambiada, no podrás utilizar la contraseña anterior.</p>
                    <PasswordResetForm @success="onSuccess" @error="onError"/>
                </div>
            </div>
        </div>
        <PasswordResetThanksModal />
    </div>
</template>

<script>
import AnimationPasswordForgot from '@/components/AnimationPasswordForgot'
import PasswordResetForm from '@/components/PasswordResetForm'
import PasswordResetThanksModal from '@/components/PasswordResetThanksModal';

export default {
    name: 'PageForgotPass',
    components:{
        AnimationPasswordForgot,
        PasswordResetForm,
        PasswordResetThanksModal
    },
    methods : {
        onSuccess() {
            this.showModal({success: true, error: false });
        },
        onError(e) {
            this.showModal({success: false, error: true, error_msg: e });
        },
        showModal(args){
            this.$modal.show('reset-password-modal', args);
        }
    }
}
</script>

<style lang="scss">
[data-scroll-class] {
    opacity: 1;
}
.bg-dashed-circle{
    background: url('../assets/images/bg-1.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center 120px;
    background-attachment: fixed;
}
// Page Forgot Password
.forgot-pass--content {
    display: flex;
    align-items: center;
    height: 100%;
    min-height: 730px;

    h1 {
        font-family: $primary-font;
        color: $orange-dark-color;
        font-size: $extra-large-font-size;
    }

    p {
        font-size: $small-font-size;
    }

    .forgot-pass--img {
        position: relative;
        max-width: 386px;
        width: 100%;
        // padding-top: 80px;
        // padding-bottom: 40px;

        .forgot-pass {
            position: absolute;
            top: -200px;
            left: -150px;
            right: 90px;
        }
    }
}
.lottie-animation__forgot-pass {
    svg {
        width: 150%!important;
    }
}

// Medium devices (desktop, 991px)
@media screen and (max-width: 991px) {
    .forgot-pass--content {
        flex-direction: column;
        text-align: center;

        h1 {
            font-size: $large-font-size;
            max-width: 400px;
            width: 100%;
            margin: 0 auto;
        }

        p {
            font-size: $extra-small-font-size;
            margin-top: 15px;
        }

        .forgot-pass--img {
            padding-top: 180px;
            padding-bottom: 160px;

            .forgot-pass {
                bottom: 0;
                left: -205px;
                right: 200px;
                top: 0;
            }
        }
        .forgot-pass--text {
            max-width: 80%;
        }
    }
    .lottie-animation__forgot-pass {
        svg {
            width: 200%!important;
        }
    }
}
// Medium devices (tablet, 768px)
@media screen and (max-width: 768px) {
    .forgot-pass--content {
        .forgot-pass--img {
            position:relative!important;

            .forgot-pass {
                bottom: 0;
                right: 250px;
                top: 0;
            }
            img {
                height: 300px;
            }
        }

        .lottie-animation__forgot-pass {
            svg {
                width: 225%!important;
            }
        }
    }
}
// Medium devices (mobile 576px)
@media screen and (max-width:576px) {
    .forgot-pass--content {
        .forgot-pass--img {

            .forgot-pass {
                left: -250px;
            }
        }
    }
}
// Medium devices (mobile 480px)
@media screen and (max-width:480px) {
    .forgot-pass--content {

        h1 {
            font-size: $mobile-large-font-size;
        }

        .forgot-pass--img {

            .forgot-pass {
                right: 255px;
            }
        }

        .forgot-pass--text {
            max-width: 95%;
        }
    }
}
// Medium devices (mobile 380px)
@media screen and (max-width:380px) {
    .forgot-pass--content {

        .forgot-pass--img {

            .forgot-pass {
                right: 230px;
            }
        }
    }
}
</style>